module.exports = __webpack_public_path__ + "img/taiwanrecall.6adb18e3.png";